<template>
  <div class="property-filter">
      <input-radio-select class="property-filter__input" icon="bed" :selections="bedsSelections" v-model="inputBeds"/>
      <!-- <input-radio-select class="property-filter__input" icon="shower" :selections="bathsSelections" v-model="inputBaths"/> -->
      <!-- <input-radio-select class="property-filter__input" icon="car" :selections="carsSelections" v-model="inputCars"/> -->
  </div>
</template>
<script>
import InputRadioSelect from './InputRadioSelect'
export default {
  components: { InputRadioSelect },

  data () {
    return {
      bathsSelections: [
        { label: 'Any', value: false },
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4+', value: 4 },
      ],
      bedsSelections: [
        { label: 'Any', value: false },
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4+', value: 4 }
      ],
      carsSelections: [
        { label: 'Any', value: false },
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4+', value: 4 },
      ]
    }
  },

  computed: {
    inputBaths: {
      get () {
        return this.$store.state.property.inputBaths
      },
      set (value) {
        this.$store.commit('property/SET_FILTER_PARAMETERS', {
          inputBaths: value
        })
      }
    },

    inputBeds: {
      get () {
        return this.$store.state.property.inputBeds
      },
      set (value) {
        this.$store.commit('property/SET_FILTER_PARAMETERS', {
          inputBeds: value
        })
      }
    },

    inputCars: {
      get () {
        return this.$store.state.property.inputCars
      },
      set (value) {
        this.$store.commit('property/SET_FILTER_PARAMETERS', {
          inputCars: value
        })
      }
    },
  }
}
</script>
<style lang="scss">
.property-filter {
  &__input {
    margin-bottom: 1rem;
  }
}
</style>